// extracted by mini-css-extract-plugin
export default {"notfound_container":"NotFound_notfound_container__8QD9H","notfound_box":"NotFound_notfound_box__KciSu","warn":"NotFound_warn__DviBK"};